//core modules
import React, {createContext, useContext, useEffect, useState} from "react";
import { useParams } from 'react-router-dom';

//internal modules
import requestApi from "../../../services/requestApi.service";
import {confirmBoxWithImage, getPaymentInfo, getSessionValue, parseJSON, proceeToLink, showToast} from "../../../Common/Appcommon";

const appType = parseInt(getSessionValue("appType"));

const StepsContext = createContext();

const useStepsContext = () => useContext(StepsContext);

const StepsProvider = ({children}) => {
    const {subscriptiontype} = useParams();
    //specifies the current step of the subscription
    const [currentStep, setCurrentStep] = useState(1);

    //specifies the plan selected
    const [plan, setPlan] = useState('');
    const [planMonths, setPlanedMonths] = useState(0);

    //contains payment related details
    const [paymentInfo, setPaymentInfo] = useState([]);

    const [billingInfo, setBillingInfo] = useState([]);

    //specifies the selected users count
    const [requiredUsers,setRequiredUser] = useState('');
    const [addRequiredUsers,setAddRequiredUsers] = useState('');

    //contains applicable pricing info
    const [subTotal, setSubTotal] = useState(0);
    const [addSubTotal, setAddSubTotal] = useState(0);

    const [total, setTotal] = useState(0);
    const [addTotal, setAddTotal] = useState(0);

    const [tax, setTax] = useState(0);
    const [gatewayCharges, setGateWayCharges ] = useState(0);
    const [TDS, setTDS ] = useState(0);
    const [prevPaymentDeduction, setPreviosPaymentDeduction] = useState(0);
    const [proRataCharges, setProRataCharges] = useState(0);
    const [netAmount, setNetAmount] = useState(0);
    const [tdsPercentage, setTDSPercentage] = useState(0);

    //payment methods
    const [paymentMethod, setPaymentMethod] = useState();

    //spcifies the price of a single user
    const [pricePerUser, setPricePerUser ] = useState(0);

    //specifies if its subscription update or create.
    const [isPricingUpdate, setIsPricingUpdate] = useState(false);

    //specifies if its subscription update and current subscription is still active.
    const [isEarlyUpdate, setIsEarlyUpdate] = useState(false);

    //specifies the count of  already subscription paid users.
    const [paidUsers, setPaidUsers] = useState(0);

    // check whether previous payment is subscription or manual payment.
    const [isPrevPricingSub, setIsPrevPricingSub] = useState(false);
    const [customerPaymentType, setCustomerPaymentType] = useState("");

    //used to show loader widget.
    const [showLoader, setShowLoader] = useState(true);
    
      /*
       * specifies the subscription flow types.
       * ==================
       *
       * 0 - manual subscription.
       * 1 - manual subscription update with increased user count.
       * 2 - recurring subscription.
       * 3 - recurring subscription with increased user count.
       * 4 - recurring subscription with decreased user count.
       * 5 - manual to recurring subscription with increased user count.
       * 6 - recurring to manual subscription with increased count.
       * 7 - recurring to manual subscription with decreased count.
       * 8 - manual to subscription to add extra date.
       * 9 - Re-Subscribe
       * 10 - Customized Addons
       * 11 - Reduce Addons
       * 12 - renewal by razorpay
       * 13 - emandate subscription
       * 14 - emandate with increased user count.
       * 15 - emandate with increased user count above max_amount.
       * 17 - upgrade license days with new plan.
       * 
       * */
    
    const [usageType, setUsageType] = useState(0);

    //specifies the type of the selected payment.
    const [isRecurringPayment, setIsRecurringPayment] = useState(false);

    // Addons Counts.
    const [addOnsRecord, setAddOnsRecord] = useState(0);
    const [callRec, setCallRec] = useState(30);
    const [whatsappApi, setWhatsappApi] = useState(false);
    const [cloudTele, setCloudTele] = useState(false);
    // addons values
    const [isAddonEnbled, setIsAddonEnbled] = useState(false);
    const [addOnsRecordVal, setAddOnsRecordVal] = useState(0);
    const [callRecVal, setCallRecVal] = useState(0);
    const [whatsappApiVal, setWhatsappApiVal] = useState(0);
    const [cloudTeleVal, setCloudTeleVal] = useState(0);
    const [oldCallRecVal, setOldCallRecVal] = useState(0);
    const [addOnsTotal, setAddOnsTotal] = useState(0);

    const [currentBill, setCurrentBill] = useState(0);
    const [licenseEndDate, setLicenseEndDate] = useState();
    const [recordsOption, setRecordsOption] = useState([0]);
    const [callRecOption, setCallRecOption] = useState([]);
    const [lastPaymentData, setLastPaymentData] = useState([]);
    const [isEMandate, setIsEMandate] = useState(false);
    const [maxAmount, setMaxAmount] = useState(0);
    const [paymentDetails, setPaymentDetails] = useState({});
    const [subscriptionType, setSubscriptionType] = useState('');
    const [emandateEAP, setEmandateEAP] = useState(0);
    const [offerType, setOfferType] = useState();

    // Current Available Plans
    const [showSubscription, setShowSubscription] = useState(false);
    const [showOnline, setShowOnline] = useState(true);
    const [showEmandate, setShowEmandate] = useState(false);
    const [maxSubAmount, setMaxSubAmount] = useState(15000);
    const [paymentsMethods , setPaymentsMethods] = useState([])

    useEffect(()=>{
        (async () => {
            let paymentAvalable = await getPaymentDetails();
            const data = await getPaymentInfo();
            await getAddonsOptions();
            //prefill the current pricing details in states.
            let billingInfo = await getBillingInfo();
            let end_date = await processBillingandPaymentInfo(billingInfo, data, paymentAvalable);
            await updatePricingConfiguration(data, end_date);
            setPaymentInfo([...data]);
            setShowLoader(false);
        })();
    }, []);

    useEffect(()=>{
        (async () => {
            if(!showEmandate && !showOnline && !showSubscription){
                let cancel = {};
                cancel.visible = false;
                await confirmBoxWithImage(
                    "Payment Gateway Currently Unavailable",
                    "1.   We apologise, but our payment gateway is currently experiencing technical difficulties. You may be unable to complete transactions at this time.\n\n 2.   Our team is working to resolve the issue as quickly as possible. Thank you for your patience and understanding.\n\n 3.   For urgent assistance, please contact our customer support at [support@cratio.com] or [+91-7418191100].",
                    "",
                    "Quit Page",
                    "",
                    cancel
                );
                proceeToLink("/#/settings/account/subscription", false);
            }
        })();
    }, [showOnline]);

    const getPaymentDetails = async () => {
        let paymentsMethods = [];
        let params = {
            "ENTITY": "razorpay",
            "OPERATION" : 'GET_PAYMENTS_DETAILS'
        }
        let res = await requestApi.processServerRequest(params);
        if(res.issuccess){
            paymentsMethods = res.data;
            if(Object.keys(paymentsMethods).length > 0){
                let subscriptions = paymentsMethods["subscription"];
                setShowSubscription(paymentsMethods["subscription_enabled"]);
                setShowOnline(paymentsMethods["online_enabled"]);
                setShowEmandate(paymentsMethods["emandate_enabled"]);
                if(Object.keys(subscriptions).length > 0){
                    setMaxSubAmount(subscriptions[0]['max_amount']);
                }
            }
        }
        setPaymentsMethods(paymentsMethods);
        return paymentsMethods;
    }

    const processBillingandPaymentInfo = async (billingInfo, paymentInfo, paymentAvalable) => {
        setOfferType(paymentInfo[29] ?? "Regular");
        let end_date = "";
        if(billingInfo[0]['license_end_date'] !== undefined && billingInfo[0]['license_end_date'] !== null && billingInfo[0]['license_end_date'] !== ""){
            end_date = billingInfo[0]['license_end_date'];
        }else{
            end_date = billingInfo[1]['license_end_date']
        }
        setLicenseEndDate(end_date);
        let paymentDetail = billingInfo[1]['paymentdetails'];
        if(paymentDetail){
            paymentDetail = parseJSON(billingInfo[1]['paymentdetails']);
            setPaymentDetails(paymentDetail);
        }
        if(paymentDetail && paymentInfo[28] === "Yes" && paymentInfo[17] === "Recurring"){
            if(paymentDetail['method'] === "Emandate" && paymentAvalable["emandate_enabled"]){
                let items = paymentDetail['items'];
                setIsEMandate(true);
                setPaymentMethod(items['paymentmethod']);
                let max_amount = paymentDetail['items']["max_amount"];
                max_amount = (max_amount / 100);
                setMaxAmount(max_amount);
            };
        }
        if(paymentInfo[29] !== ""){
            setEmandateEAP(parseInt(paymentInfo[29]))
        }
        const paymentTypeBySubId = paymentInfo[paymentInfo.length - 2];
        setSubscriptionType(paymentInfo[17]);
        if(paymentInfo[17] === "addonusers" && paymentTypeBySubId === "Subscription"){
            setUsageType(3);
        }else if(paymentInfo[17] === "reduceusers" && paymentTypeBySubId === "Subscription"){
            setUsageType(4);
        }
        if(paymentInfo[27] === "Yes"){
            setIsAddonEnbled(true);
            await setAddonsValues(paymentInfo, billingInfo);
            if(subscriptiontype === "addons"){
                setUsageType(10);
            }
        }
        checkCurrentURLIsValid(paymentInfo[27] === "Yes");
        return end_date;
    }

    const setAddonsValues = async (data, billingInfo) => {
        if(data.length > 0 && billingInfo[2] !== undefined && data[25] !== null && data[26] !== ""){
            let isAddOnsRec = billingInfo[2]["total_record_count"];
            let isAddOnsCall = billingInfo[2]["call_rec_storage_size"];
            let isWhastapp = billingInfo[2]["whatsapp_api"];
            let isCloudTele = billingInfo[2]["cloud_telephony"];
            let noofusers = parseInt(billingInfo[1]['number_of_user']);
            let preUserCharge = 0;
            let addonsRecAmount = 0;
            let callRecAmount = 0;
            let addonsWhatsappAmount = 0;
            let addonsCloudAmount = 0;
            let noofmonth = 0;
            let addonsTotalAmount = 0;

            if(data['7'] === 'Monthly'){
                noofmonth = 1;
                preUserCharge = parseInt(data[0]) * noofmonth;
            }else if(data['7'] === 'Quarterly'){
                noofmonth = 3;
                preUserCharge = parseInt(data[1]) * noofmonth;
            }else if(data['7'] === "Half Yearly"){
                noofmonth = 6;
                preUserCharge = parseInt(data[2]) * noofmonth;
            }else if(data['7'] === "Annual"){
                noofmonth = 12;
                preUserCharge = parseInt(data[3]) * noofmonth;
            }

            if(Object.keys(isAddOnsRec).length > 0 && false){
                addonsRecAmount = parseInt(data[20]) * isAddOnsRec['value'] / 50000 * noofmonth;
                addonsTotalAmount = addonsTotalAmount + addonsRecAmount;
                setAddOnsRecordVal(addonsRecAmount);
                setAddOnsRecord(isAddOnsRec);
            }

            if(Object.keys(isAddOnsCall).length > 0){
                let amount = 0;
                let month = isAddOnsCall['value'] / 30;
                if(isAddOnsCall['value'] !== 30){
                    amount = month * parseInt(data[21]);
                }
                callRecAmount = amount;
                addonsTotalAmount = addonsTotalAmount + amount;
                setOldCallRecVal((parseInt(billingInfo[1]['call_rec_storage_size']) / 30) * parseInt(data[21]))
                setCallRecVal(amount);
                callRecAmount = callRecAmount * parseInt(data[24]);
            }

            if(isWhastapp){
                addonsWhatsappAmount = parseInt(data[22]) * noofmonth;
                addonsTotalAmount = addonsTotalAmount + addonsWhatsappAmount;
                setWhatsappApiVal(addonsWhatsappAmount);
                addonsWhatsappAmount = addonsWhatsappAmount * parseInt(data[25]);
            };

            if(isCloudTele){
                addonsCloudAmount = parseInt(data[23]) * noofmonth;
                addonsTotalAmount = addonsTotalAmount + addonsCloudAmount;
                setCloudTeleVal(addonsCloudAmount);
                addonsCloudAmount = addonsCloudAmount * parseInt(data[26]);
            }

            setCallRec(isAddOnsCall);
            setWhatsappApi(isWhastapp);
            setCloudTele(isCloudTele);
            setAddOnsTotal(addonsTotalAmount);
            setCurrentBill((noofusers * preUserCharge) + addonsRecAmount + callRecAmount + addonsWhatsappAmount + addonsCloudAmount);
        }
    }

    const getAddonsOptions = async () => {
        let result = [];
        let params = {
            "ENTITY": "razorpay",
            "OPERATION" : 'GET_ADDONS_OPTIONS'
        }
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            result = response.data;
            setRecordsOption(result[0] !== undefined && result[0] !== null ? result[0] : []);
            setCallRecOption(result[1] !== undefined && result[1] !== null ? result[1] : []);
        }
    }

    const updatePricingConfiguration = async (data, license_end_date) => {
        const paymentTypeBySubId = data.length > 0 ? data[data.length - 2] : "";
        //check whether it's a pricing update.
        setCustomerPaymentType(paymentTypeBySubId);
        let end_date = new Date(license_end_date); // Parse the date from the data array
        // Add one day
        end_date.setDate(end_date.getDate() + 1);
        let isEarlyUpdate = end_date >= new Date();
        setIsEarlyUpdate(isEarlyUpdate);
        
        if(data['15'] !== undefined && data['15'] === "Customer"){
            //start from 2nd page if it's recurring subscription or subscription not finished yet.
            if((paymentTypeBySubId === "Subscription") || (paymentTypeBySubId !== "Subscription" && isEarlyUpdate)){
                setIsPricingUpdate(true);
                setPaidUsers(data['18']);
                setIsPrevPricingSub(paymentTypeBySubId === "Subscription");

                
                if(data['7'] === `Monthly`){
                    setPricePerUser(data['0']);
                    setPlan("Monthly");
                    setPlanedMonths(1);
                }else if(data['7'] === `Quarterly`){
                    setPricePerUser(data['1']);
                    setPlan("Quarterly");
                    setPlanedMonths(3);
                }else if(data['7'] === `Half Yearly`){
                    setPricePerUser(data['2']);
                    setPlan("Half Yearly");
                    setPlanedMonths(6);
                }else if(data['7'] === `Annual`){
                    setPricePerUser(data['3']);
                    setPlan("Annually");
                    setPlanedMonths(12);
                }

                //don't allow to select plan when it's pricing update. expected Online Payment Type
                // if(currentStep === 1 && subscriptiontype !== undefined && ((data[13] === "subscription" && billingInfo[0]['subscriptionid'] === null) || (data[13] === "Online" && billingInfo[0]['subscriptionid'] !== null))){
                //     setCurrentStep(2);
                // }
            }
        }
    }

    const getBillingInfo = async () => {
        let result = [];
        let params = {
            "ENTITY": "razorpay",
            "OPERATION" : 'GET_BILLINGINFO'
        }
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let billingData = response.data;
            setBillingInfo(response.data);
            // let isSub = data[13] === "Subscription" && billingData[0]['subscriptionid'] !== null && billingData[0]['paymentstatus'] !== "'Cancelled";
            let isOnline = billingData[0]['subscriptionid'] === "Online" && billingData[0]['paymenttype'] !== "Emandate";
            let isPrevSub = billingData[0]['subscriptionid'] === "Subscription" || billingData[0]['paymenttype'] === "Emandate";
            let paymentstatus = billingData[0]['paymentstatus'];
            // if(((!isSub) && subscriptiontype !== undefined) || ((!isOnline && isPrevSub) || (isOnline && subscriptiontype !== undefined))){
            //     setCurrentStep(2);
            // }
            if(subscriptiontype === "addonusers" || (Object.keys(billingData[0]).length > 0 && (isPrevSub && paymentstatus !== "Cancelled" && paymentstatus !== "Inactive" || (isOnline && subscriptiontype !== undefined)) && subscriptiontype !== "upgrade")){
                setCurrentStep(2);
            }
            result = billingData;
        }
        return result;
    }

    const resetSubscriptionInfo = () => {
        setRequiredUser('');
        setSubTotal('');
        setTotal('');
    }

    const updateUsageType = (recurringType=isRecurringPayment, subtotal = subTotal) => {
        
        let subAmountTax = (subtotal * 18) / 100;
        const calculatedTotal = subtotal + subAmountTax;
        
        if(paymentInfo && paymentInfo[13] === "Subscription"){
            if(calculatedTotal < 15000){
                setSubscriptionType('Recurring');
                setIsEMandate(true);
            } else {
                setSubscriptionType('Non Recurring');
                setIsEMandate(false);
            }
        } else if (calculatedTotal > 15000) {
             // For any other case, if amount > 15000, force non-recurring
             setSubscriptionType('Non Recurring');
             setIsEMandate(false);
        }

        let type = 0;
        const paymenttype = paymentInfo[paymentInfo.length - 2];
        if(subscriptiontype === "upgrade"){
            type = 17;
        }else if(isEMandate && subscriptiontype === "reduceusers" && paymentInfo[28] === "Yes"){
            type = 16;
        }else if(isEMandate && subscriptiontype === "addonusers" && ((subtotal + subAmountTax) > maxAmount) && paymentInfo[28] === "Yes"){
            type = 15;
        }else if(isEMandate && subscriptiontype === "addonusers" && ((subtotal + subAmountTax) <= maxAmount) && paymentInfo[28] === "Yes"){
            type = 14;
        }else if(isEMandate && subscriptiontype === undefined){
            type = 13;
        }else if(isEarlyUpdate && subscriptiontype === "addons"){
            if(subtotal > 0 && subtotal < currentBill){
                type = 11;
            }else{
                type = 10;
            }
        }else if(isEarlyUpdate && subscriptiontype === undefined && paymenttype === "Subscription"){
            type = 9;
        }else if(isEarlyUpdate && subscriptiontype === undefined && paymenttype !== "Subscription"){
            type = 8;
        }else if(isEarlyUpdate && subscriptiontype === "addonusers" && paymenttype === "Online"){
            type = 1;
        }else if(isEarlyUpdate && !recurringType && isPrevPricingSub && requiredUsers < paidUsers){
            type = 7;
        }else if(isEarlyUpdate && !recurringType && isPrevPricingSub && requiredUsers > paidUsers){
            type = 6;
        }else if(isEarlyUpdate && recurringType && !isPrevPricingSub && requiredUsers > paidUsers){
            type = 5;
        }else if((isEarlyUpdate && recurringType && requiredUsers < paidUsers) || (subscriptiontype === "reduceusers" && recurringType)){
            type = 4;
        }else if((isEarlyUpdate && recurringType && requiredUsers > paidUsers) || (subscriptiontype === "addonusers" && recurringType)){
            type = 3;
        }else if(recurringType){
            type = 2;
        }else if(isEarlyUpdate && !recurringType && subscriptiontype === "addonusers"){
            type = 1;
        }

        setUsageType(type);

        return type;
    }

    const checkCurrentURLIsValid = (addonEnabled = isAddonEnbled, lastpayment = lastPaymentData) => {
        const paymentTypeBySubId = paymentInfo[paymentInfo.length - 2];
        let isRedirect = false;
        let isAddUsersPage = subscriptiontype === "addonusers";
        let isReducePage = subscriptiontype === "reduceusers";
        let isAddonsPage = subscriptiontype === "addons";
        let isUpgrade = subscriptiontype === "upgrade";
        if(isUpgrade){
            if(paymentTypeBySubId === "Offline"){
                isRedirect = true
            }
        }else if(isEarlyUpdate && paymentTypeBySubId === "Subscription" && subscriptiontype === undefined){
            const paymentStatus = billingInfo[0] !== undefined ? billingInfo[0]["paymentstatus"] : "";
            if(paymentStatus !== "Cancelled" && paymentStatus !== "Completed" && paymentStatus !== "Expired" && paymentStatus !== "Halted"){
                // once subscribe after don't allow subscription page. if 
                isRedirect = true;
            }
        }else if(isReducePage && paymentTypeBySubId === "Online"){
            // only can reduce user for subscription customers
            isRedirect = true;
        }else if(isAddonsPage && !addonEnabled){
            isRedirect = true;
        }else if(planMonths === 0 && currentStep !== 1){
            showToast("Somthing Went wrong Error Code (#80014)", "top-right", "error");
        }else if(subscriptiontype !== undefined && !isAddUsersPage && !isReducePage && !isAddonsPage){
            isRedirect = true;
        }else if(paymentTypeBySubId === "Offline"){
            proceeToLink("/#/settings", false);
        }else if(lastpayment.length > 0){
            let subid = lastpayment[0];
            let status = lastpayment[1];
            let balancedays = lastpayment[2];
            if(subid !== null && status === "Paid" && subscriptiontype === undefined){
                isRedirect = true;
            }else if(subid !== null && status !== "Paid" && subscriptiontype !== undefined){
                isRedirect = true;
            }else if(subid === null && balancedays > 3 && subscriptiontype === undefined){
                //isRedirect = true;
            }
        }
        
        if(isRedirect){
            proceeToLink("/#/settings/account/subscription", false);
        }
    }


    return (
        <StepsContext.Provider value={{
            currentStep,
            setCurrentStep,
            plan,
            setPlan,
            paymentInfo,
            requiredUsers,
            setRequiredUser,
            subTotal,
            setSubTotal,
            total,
            setTotal,
            tax,
            setTax,
            gatewayCharges,
            setGateWayCharges,
            TDS,
            setTDS,
            pricePerUser,
            setPricePerUser,
            isPricingUpdate,
            paidUsers,
            isEarlyUpdate,
            isPrevPricingSub,
            prevPaymentDeduction,
            setPreviosPaymentDeduction,
            proRataCharges,
            setProRataCharges,
            netAmount,
            setNetAmount,
            isRecurringPayment,
            setIsRecurringPayment,
            showLoader,
            setShowLoader,
            usageType,
            tdsPercentage,
            setTDSPercentage,
            resetSubscriptionInfo,
            updateUsageType,
            customerPaymentType,
            setCustomerPaymentType,
            addRequiredUsers,
            setAddRequiredUsers,
            addSubTotal,
            setAddSubTotal,
            addTotal,
            setAddTotal,
            setUsageType,
            subscriptiontype,
            checkCurrentURLIsValid,
            maxSubAmount,
            addOnsRecord,
            setAddOnsRecord,
            callRec,
            setCallRec,
            whatsappApi,
            setWhatsappApi,
            cloudTele,
            setCloudTele,
            addOnsRecordVal,
            setAddOnsRecordVal,
            callRecVal,
            setCallRecVal,
            whatsappApiVal,
            setWhatsappApiVal,
            cloudTeleVal,
            setCloudTeleVal,
            recordsOption,
            callRecOption,
            addOnsTotal,
            setAddOnsTotal,
            currentBill,
            billingInfo,
            licenseEndDate,
            isAddonEnbled,
            oldCallRecVal,
            planMonths,
            setPlanedMonths,
            isEMandate, 
            setIsEMandate,
            paymentMethod, 
            setPaymentMethod,
            paymentDetails,
            maxAmount,
            showSubscription,
            showOnline,
            showEmandate,
            subscriptionType,
            setSubscriptionType,
            emandateEAP,
            offerType,
            paymentsMethods
        }}>
            {children}
        </StepsContext.Provider>
    );
}

export {useStepsContext, StepsProvider};
